import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InvitationService } from './service/invitation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'weddingForm';
  public form: FormGroup;
  public contactList: FormArray;
  public partecipanti: number;
  fakeArray: any[];
  success = false;
  codice = "";
  uEmail: any;
  usedEmails = [];
  errorUsedEmail = false;
  successfullsent = false;

  get contactFormGroup() {
    return this.form.get('contacts') as FormArray;
  }

  constructor(private fb: FormBuilder, private invitationService: InvitationService) {}

  ngOnInit() {
    this.invitationService
    .getAllEmails()
    .subscribe(data=>{
      this.uEmail = data;
      for(let i=0; i<this.uEmail.length; i++){
        this.usedEmails.push(this.uEmail[i]['email']);
      }
    });
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      numeropartecipanti: [null, Validators.compose([Validators.required])],
      email: [null,  Validators.compose([
        Validators.required,
        Validators.email
      ])],
      telefono: [null],
      dataarrivo: [null],
      aereoporto: [null],
      trasporto: [null, Validators.compose([Validators.required])],
      contacts: this.fb.array([this.createContact()])
    });
    this.contactList = this.form.get('contacts') as FormArray;
  }

  createContact(): FormGroup {
    return this.fb.group({
      name: [null, Validators.compose([Validators.required])], 
      type: [null, Validators.compose([Validators.required])],
      allergie: [null, Validators.compose([Validators.required])]
    });
  }

  addContact() {
    this.contactList.push(this.createContact());
  }

  removeContact(index) {
    this.contactList.removeAt(index);
  }

  changedFieldType() {

  }

  getContactsFormGroup(index): FormGroup {
    const formGroup = this.contactList.controls[index] as FormGroup;
    return formGroup;
  }

  partecipantichange(event) {
    this.partecipanti = event.target.value;
    let diff = this.partecipanti -this.form.value.contacts.length;
    this.form.value.contacts = [];
    this.contactList.clear();
    for(let i=0;i<this.partecipanti;i++){
      this.addContact();
    }
  }

  submit() {
    this.invitationService
      .postInvitation(this.form.value)
      .subscribe(
        data => {
          this.codice = data['success'];
          if(this.codice !== ""){
            this.success = true;
            this.successfullsent = true;
          }
      }
    );
  }

  checkemail(event){
    let inside = this.usedEmails.includes(event.target.value);
    if(inside == true){
      this.errorUsedEmail = true;
    }else{
      this.errorUsedEmail = false;
    }
  }

  
}
